import React, { createContext, useReducer, useContext } from "react";
import { StateType, ActionType } from "../../types/contextType";
import Reducer from "./reducer";

const initialState: StateType = {
  user: undefined,
  loading: false,
  authenticated: false,
  externalUrls: {
    mobility_devices_policy_and_administration_manual: "",
    mobility_devices_product_manual: "",
    motion_accessibility_policy: "",
    motion_privacy_policy: "",
    ontario_gov_adp_form_downloads: "",
  },
  filter: {cep: null, status: null, locations: null, unassigned: null},
};

const StoreContext = createContext<{
  state: StateType;
  dispatch: React.Dispatch<ActionType>;
}>({ state: initialState, dispatch: () => null });

export const useStoreContext = () => {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error("useStoreContext must be used within a StoreProvider");
  }
  return context;
};

const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);

  return (
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreProvider;
